import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Draggable, Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useEffect, useRef } from 'react';
const useDraggableInPortal = () => {
    const self = useRef({}).current;
    useEffect(() => {
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.pointerEvents = 'none';
        div.style.top = '0';
        div.style.width = '100%';
        div.style.height = '100%';
        self.elt = div;
        document.body.appendChild(div);
        return () => {
            document.body.removeChild(div);
        };
    }, [self]);
    return (render) => (provided, ...args) => {
        var _a, _b;
        const element = render(provided, ...args);
        if (((_b = (_a = provided.draggableProps) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.position) === 'fixed') {
            return createPortal(element, self.elt);
        }
        return element;
    };
};
const DragNDropList = ({ values, droppableId, renderValue, valueIdGetter, noItemsLabel, ListComponent }) => {
    const renderDraggable = useDraggableInPortal();
    return (_jsx(ListComponent, { children: _jsx(Droppable, { droppableId: droppableId, children: (provided, snapshot) => (_jsxs("div", { ref: provided.innerRef, style: { height: '100%' }, children: [(values === null || values === void 0 ? void 0 : values.length)
                        ? values.map((value, index) => {
                            return (_jsx(Draggable, { draggableId: valueIdGetter(value), index: index, children: renderDraggable((draggableProvided) => (_jsx("div", Object.assign({ ref: draggableProvided.innerRef }, draggableProvided.draggableProps, draggableProvided.dragHandleProps, { children: renderValue(value, draggableProvided) })))) }, valueIdGetter(value)));
                        })
                        : noItemsLabel, provided.placeholder] })) }) }));
};
DragNDropList.propTypes = {
    droppableId: PropTypes.string.isRequired,
    noItemsLabel: PropTypes.element.isRequired,
    ListComponent: PropTypes.element.isRequired,
    renderValue: PropTypes.func.isRequired,
    valueIdGetter: PropTypes.func.isRequired,
    values: PropTypes.instanceOf(Array).isRequired,
};
export default DragNDropList;
